<template>
<div class="main-cont">
    <div class="con-sal">
        <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
    </div>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="cont-date">
                <v-date-picker v-model="date" mode="dateTime" is-range />
            </div>
            <a href="#" class="btn btn-outline-success btn-sm" @click="avviaAnalisi">Avvia Analisi</a>
        </div>    
        <div class="tab-cont">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text">COPERTI</th>
                        <th class="text">COSTO MATERIE PRIME</th>
                        <th class="text">RICAVO</th>
                        <th class="text">GUADAGNO</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr>
                            <td class="text pointer" >{{}}</td>
                            <td class="text" >{{this.spesa}}</td>
                            <td class="text" >{{this.incasso}}</td>
                            <td class="text" >{{this.incasso - this.spesa}}</td>
                        </tr>
                    </tbody>
            </table>
        </div>
        
    </div>
    </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import { store } from '../store/store.js'
export default {
  name: 'RiepilogoAndamento',
  data: function () {
            return {
                incasso:'',
                spesa:'',
                date: new Date(),
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    avviaAnalisi() {
        this.moment = moment;
        var end = moment(this.date.end).endOf('day').unix();
        var start = moment(this.date.start).startOf('day').unix();
        console.log(start, end)
        this.axios.post(this.store.path+'getAnalisi',{start:start,end:end,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data)
            if(response.data){
                this.incasso = response.data.incasso;
                this.spesa= response.data.spesa;
                console.log('Analisi dei costi caricata')
            }else{console.log("Non è stato possibile creare  l'analisi dei costi")}
        })
    },
  
  },
  beforeMount() {
      //this.anaCosti();
  },
}
</script>

<style scoped>
.m-cont {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.text {
    color: rgb(0, 0, 0);
}
.scan {
    display:flex;
    flex-direction: column;
}
.tab-cont {
    margin: auto;
    margin-top: 20px;
}
.main-cont {
    display: flex;
    flex-direction: column;
}
</style>